import { _ as o } from "./main58.js";
import { _ as r } from "./main59.js";
import { _ as i } from "./main60.js";
import { _ as h } from "./main61.js";
import { _ as p } from "./main62.js";
var c = o, C = r, _ = i, m = h, f = p;
function t(e) {
  var a = -1, l = e == null ? 0 : e.length;
  for (this.clear(); ++a < l; ) {
    var s = e[a];
    this.set(s[0], s[1]);
  }
}
t.prototype.clear = c;
t.prototype.delete = C;
t.prototype.get = _;
t.prototype.has = m;
t.prototype.set = f;
var u = t;
export {
  u as _
};
